import { isArray, isNil } from 'lodash';
import * as orderDiscountService from 'services/orderDiscountService';
import useSWR, { mutate } from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWROrderDiscountsData = Awaited<
  ReturnType<typeof orderDiscountService.getOrderDiscountsAsync>
>;

const useOrderDiscounts = (
  orderId: number,
  load = true
): SWRResponse<SWROrderDiscountsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_DISCOUNTS_ENDPOINT, orderId] : null,
    async ([_, orderId]) => await orderDiscountService.getOrderDiscountsAsync(orderId)
  );

export const mutateOrderDiscounts = async (orderId?: number): Promise<unknown> =>
  await mutate(
    (key) =>
      isArray(key) &&
      key[0] === SWR_ORDER_DISCOUNTS_ENDPOINT &&
      (isNil(orderId) || key[1] === orderId),
    undefined
  );

export const SWR_ORDER_DISCOUNTS_ENDPOINT = 'order-discounts';
export default useOrderDiscounts;
